import { IQuestionnaire } from '@cmr/inflow-js-common';
import { ApiError } from '@cmr/react-api-hook';
import { ActionType, createAction, createAsyncAction } from 'typesafe-actions';

export const actions = {
  fetch: createAsyncAction('fetch/request', 'fetch/success', 'fetch/failure')<
    undefined,
    IQuestionnaire[],
    ApiError
  >(),
  getRevision: createAsyncAction(
    'getRevision/request',
    'getRevision/success',
    'getRevision/failure',
  )<undefined, IQuestionnaire, ApiError>(),
  questionnaireStatusChange: createAction(
    'signalR/QuestionnaireStatusChange',
  )<IQuestionnaire>(),
};

export default actions;

export type QuestionnairesAction = ActionType<typeof actions>;
